import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { PayrollCalendarRequest } from '../payrollCalendar.types';

export const useUpdatePayrollCalendarQuery = (calendarId?: string) => {
  const { mutateAsync, isLoading } = useMutation((request: PayrollCalendarRequest) =>
    api.put(API_URL.PAYROLL_CALENDARS_BY_ID(calendarId || ''), request)
  );

  const updateCalendar = useCallback(
    async (params: PayrollCalendarRequest) => {
      await mutateAsync(params);
    },
    [mutateAsync]
  );

  return {
    updateCalendar,
    isLoading,
  };
};
